import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const ArrowDownIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "m6.998 11.586-3.3-3.293A1.003 1.003 0 0 0 2 9.003a.999.999 0 0 0 .281.704l5.01 5a1.003 1.003 0 0 0 1.417 0l5.01-5a1 1 0 0 0-.711-1.695 1.003 1.003 0 0 0-.705.281l-3.3 3.293V2A.999.999 0 0 0 8 1a1.003 1.003 0 0 0-1.002 1v9.586Z", fill: "currentColor" })));
});
ArrowDownIcon.displayName = 'ArrowDownIcon';
export default ArrowDownIcon;
